// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetCurrencies (params?: {}): Promise<List>;
    publicGetProducts (params?: {}): Promise<List>;
    publicGetProductsId (params?: {}): Promise<Dict>;
    publicGetProductsIdBook (params?: {}): Promise<Dict>;
    publicGetProductsIdCandles (params?: {}): Promise<List>;
    publicGetProductsIdStats (params?: {}): Promise<Dict>;
    publicGetProductsIdTicker (params?: {}): Promise<Dict>;
    publicGetProductsIdTrades (params?: {}): Promise<List>;
    publicGetTime (params?: {}): Promise<Dict>;
    publicGetProductsSparkLines (params?: {}): Promise<Dict>;
    publicGetProductsVolumeSummary (params?: {}): Promise<List>;
    privateGetAddressBook (params?: {}): Promise<List>;
    privateGetAccounts (params?: {}): Promise<Dict>;
    privateGetAccountsId (params?: {}): Promise<Dict>;
    privateGetAccountsIdHolds (params?: {}): Promise<List>;
    privateGetAccountsIdLedger (params?: {}): Promise<List>;
    privateGetAccountsIdTransfers (params?: {}): Promise<List>;
    privateGetCoinbaseAccounts (params?: {}): Promise<List>;
    privateGetFills (params?: {}): Promise<List>;
    privateGetFunding (params?: {}): Promise<Dict>;
    privateGetFees (params?: {}): Promise<Dict>;
    privateGetMarginProfileInformation (params?: {}): Promise<List>;
    privateGetMarginBuyingPower (params?: {}): Promise<Dict>;
    privateGetMarginWithdrawalPower (params?: {}): Promise<List>;
    privateGetMarginWithdrawalPowerAll (params?: {}): Promise<Dict>;
    privateGetMarginExitPlan (params?: {}): Promise<Dict>;
    privateGetMarginLiquidationHistory (params?: {}): Promise<Dict>;
    privateGetMarginPositionRefreshAmounts (params?: {}): Promise<Dict>;
    privateGetMarginStatus (params?: {}): Promise<Dict>;
    privateGetOracle (params?: {}): Promise<Dict>;
    privateGetOrders (params?: {}): Promise<List>;
    privateGetOrdersId (params?: {}): Promise<Dict>;
    privateGetOrdersClientClientOid (params?: {}): Promise<Dict>;
    privateGetOtcOrders (params?: {}): Promise<List>;
    privateGetPaymentMethods (params?: {}): Promise<List>;
    privateGetPosition (params?: {}): Promise<List>;
    privateGetProfiles (params?: {}): Promise<List>;
    privateGetProfilesId (params?: {}): Promise<Dict>;
    privateGetReportsReportId (params?: {}): Promise<Dict>;
    privateGetTransfers (params?: {}): Promise<List>;
    privateGetTransfersTransferId (params?: {}): Promise<Dict>;
    privateGetUsersSelfExchangeLimits (params?: {}): Promise<Dict>;
    privateGetUsersSelfHoldBalances (params?: {}): Promise<Dict>;
    privateGetUsersSelfTrailingVolume (params?: {}): Promise<Dict>;
    privateGetWithdrawalsFeeEstimate (params?: {}): Promise<Dict>;
    privateGetConversionsConversionId (params?: {}): Promise<Dict>;
    privateGetConversions (params?: {}): Promise<List>;
    privateGetConversionsFees (params?: {}): Promise<List>;
    privateGetLoansLendingOverview (params?: {}): Promise<Dict>;
    privateGetLoansLendingOverviewXm (params?: {}): Promise<Dict>;
    privateGetLoansLoanPreview (params?: {}): Promise<Dict>;
    privateGetLoansLoanPreviewXm (params?: {}): Promise<Dict>;
    privateGetLoansRepaymentPreview (params?: {}): Promise<Dict>;
    privateGetLoansRepaymentPreviewXm (params?: {}): Promise<Dict>;
    privateGetLoansInterestLoanId (params?: {}): Promise<List>;
    privateGetLoansInterestHistoryLoanId (params?: {}): Promise<List>;
    privateGetLoansInterest (params?: {}): Promise<List>;
    privateGetLoansAssets (params?: {}): Promise<Dict>;
    privateGetLoans (params?: {}): Promise<List>;
    privatePostConversions (params?: {}): Promise<Dict>;
    privatePostDepositsCoinbaseAccount (params?: {}): Promise<Dict>;
    privatePostDepositsPaymentMethod (params?: {}): Promise<Dict>;
    privatePostCoinbaseAccountsIdAddresses (params?: {}): Promise<Dict>;
    privatePostFundingRepay (params?: {}): Promise<Dict>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostPositionClose (params?: {}): Promise<Dict>;
    privatePostProfiles (params?: {}): Promise<Dict>;
    privatePostProfilesMarginTransfer (params?: {}): Promise<Dict>;
    privatePostProfilesTransfer (params?: {}): Promise<Dict>;
    privatePostReports (params?: {}): Promise<Dict>;
    privatePostWithdrawalsCoinbase (params?: {}): Promise<Dict>;
    privatePostWithdrawalsCoinbaseAccount (params?: {}): Promise<Dict>;
    privatePostWithdrawalsCrypto (params?: {}): Promise<Dict>;
    privatePostWithdrawalsPaymentMethod (params?: {}): Promise<Dict>;
    privatePostLoansOpen (params?: {}): Promise<Dict>;
    privatePostLoansRepayInterest (params?: {}): Promise<Dict>;
    privatePostLoansRepayPrincipal (params?: {}): Promise<Dict>;
    privateDeleteOrders (params?: {}): Promise<List>;
    privateDeleteOrdersClientClientOid (params?: {}): Promise<string>;
    privateDeleteOrdersId (params?: {}): Promise<Dict>;
    privatePutProfilesIdDeactivate (params?: {}): Promise<Dict>;
    privatePutProfilesId (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
